import { combineReducers } from 'redux';

import analytics from './analytics';

const reducer = combineReducers({
    [analytics.constants.NAME]: analytics.reducer
});

export default reducer;



// WEBPACK FOOTER //
// ./src/services/google/reducer.js